import FigmaIcon from "./icons/FigmaIcon";
import React, { useMemo } from "react";
import { Box } from "@mui/material";
import StageViewAccordionList from "./job-details/StageViewAccordionList";
const TYPES = ["Email", "Action", "Note"];
const EXPANDED = { Email: true, Action: true, Note: true };
function GroupIcon({ type }) {
  if (type === "Email" || type === "Note") return <FigmaIcon name={type === "Email" ? "sms" : "note-text"} size={24} />;
  const stroke = { stroke: "currentColor", strokeWidth: 1, strokeLinecap: "round", strokeLinejoin: "round" };
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    {type === "Email" ? <><rect x="4" y="6" width="16" height="12" rx="1" {...stroke} /><path d="m4 7 8 6 8-6" {...stroke} /></>
      : type === "Note" ? <><path d="M6 4h13v16H9l-3-3V4Z" {...stroke} /><path d="M9 8h7M9 11h5" {...stroke} /></>
      : <path d="m13 2-8 12h6l-1 8 9-13h-6l1-7Z" {...stroke} />}
  </svg>;
}
export default function ActivityGroups({ items, typeFilter, resetKey, renderItem }) {
  const stages = useMemo(() => TYPES.filter(type => typeFilter === "all" || type.toLowerCase() === typeFilter)
    .map(type => ({ key: type, icon: <GroupIcon type={type} />, items: items.filter(item => {
      const value = String(item.type || "action").toLowerCase();
      return (value === "email" || value === "note" ? value : "action") === type.toLowerCase();
    }) })), [items, typeFilter]);
  const renderRows = (rows, grid = false) => <Box sx={{ display: grid ? "grid" : "flex", flexDirection: "column", gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" }, gap: 1.25 }}>
    {rows.map((item, index) => <Box key={item.id || index} sx={{ border: "1px solid #E5E7EB", borderRadius: "8px", bgcolor: "#fff", minWidth: 0, overflow: "hidden" }}>{renderItem(item)}</Box>)}
  </Box>;
  return <StageViewAccordionList stages={stages} defaultExpanded={EXPANDED} defaultView="list"
    pageSize={10} pageResetKey={resetKey} emptyText="No activities yet."
    renderList={rows => renderRows(rows)} renderGrid={rows => renderRows(rows, true)} />;
}
